export const isEmpty = (value: unknown): boolean => {
  return value === null || value === undefined || /^\s*$/.test(String(value));
};

export const isNotEmpty = (value: unknown): boolean => !isEmpty(value);
